module.exports = __webpack_public_path__ + "static/media/profil.e0f49ec4.png";